// ----------------------------------------------------------------------
// <copyright file="Izenda.RenderSwitcher.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var NotFound = require('share/components/controls/Izenda.NotFound');
  var observer = require('mobx-react').observer;
  const { find, isPlainObject, omit, assignAll } = require('lodash/fp');

  var RenderSwitcher = observer(
    React.createClass({
      render: function() {
        var props = this.props;
        var componentKey = props.componentKey;
        var restProps = omit(['componentKey', 'component'], props);

        var children = React.Children.toArray(props.children);

        var child = find(function(childComponent) {
          return childComponent.props.componentKey === componentKey;
        }, children);

        var renderingComponent = props.component;
        var renderingProps, renderingChild, renderingChildProps;

        var isRenderChildAsRoot = !renderingComponent;

        if (child) {
          var childComponent = child.props.component;
          ensure(childComponent, 'RenderSwitcher.Item requires component property');

          if (isPlainObject(childComponent)) {
            restProps = assignAll([childComponent, child.props, restProps]);
          } else {
            renderingChild = childComponent;
            renderingChildProps = omit(['componentKey', 'component'], child.props);
          }
        }

        var childElement = React.createElement(renderingChild || NotFound, renderingChildProps);

        return isRenderChildAsRoot
          ? childElement
          : React.createElement(renderingComponent, restProps, renderingChild ? childElement : null);
      }
    })
  );

  RenderSwitcher.Item = React.createClass({
    render: function() {
      return null;
    }
  });

  module.exports = RenderSwitcher;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.RenderSwitcher.jsx